var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.51C4.20653 2.70776 3.1562 5.41764 3 8.25H0C0.14607 6.51831 0.790368 4.86595 1.85508 3.49247C2.9198 2.11899 4.35939 1.08313 6 0.51ZM13.5 8.25H4.5C4.59948 6.67386 5.01066 5.13312 5.70971 3.71699C6.40876 2.30086 7.38181 1.03748 8.5725 0H9C10.3005 0.969434 11.376 2.20863 12.1527 3.63263C12.9294 5.05662 13.389 6.63174 13.5 8.25ZM18 8.25H15C14.8238 5.32077 13.6332 2.54431 11.6325 0.3975C13.3582 0.918235 14.8877 1.94514 16.023 3.34521C17.1583 4.74527 17.847 6.45398 18 8.25ZM3 9.75C3.15309 12.5853 4.2037 15.2985 6 17.4975C4.36531 16.9179 2.93289 15.8784 1.87509 14.5039C0.817293 13.1294 0.179172 11.4786 0.0375001 9.75H3ZM18 9.75C17.8498 11.5414 17.1666 13.2467 16.0384 14.6463C14.9102 16.0458 13.3887 17.0755 11.67 17.6025C13.657 15.4503 14.8342 12.6745 15 9.75H18ZM4.5 9.75H13.5C13.3474 12.0858 12.5187 14.3268 11.115 16.2C10.6855 16.776 10.2035 17.3108 9.675 17.7975C9.54049 17.9235 9.36428 17.9956 9.18 18H8.88C8.69052 17.9993 8.50832 17.927 8.37 17.7975C7.84154 17.3108 7.35947 16.776 6.93 16.2C5.51016 14.332 4.66571 12.0905 4.5 9.75Z",
    fill: "#004AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/Global.3f7715685b6ee08193935f3602c49138.svg";
export { ForwardRef as ReactComponent };